import React from 'react';
import LoginGateState from '../ui/system-states/LoginGateState';

type Props = {
  authenticated: boolean;
  children: React.ReactElement;
  /** Optional override for the gate copy (e.g. for a specific feature). */
  title?: string;
  description?: string;
  /** Путь, на который вернуть после входа через Steam (BE всегда возвращает на «/»). */
  returnTo?: string;
};

const RequireAuth: React.FC<Props> = ({ authenticated, children, title, description, returnTo }) => {
  if (!authenticated) {
    return <LoginGateState title={title} description={description} returnTo={returnTo} />;
  }
  return children;
};

export default RequireAuth;
